import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-quit-confirm-dialog',
  templateUrl: './quit-confirm-dialog.component.html',
  styleUrls: ['./quit-confirm-dialog.component.css']
})
export class QuitConfirmDialogComponent implements OnInit {
  public dialogData: any = null;
  constructor(private dialogRef: MatDialogRef<QuitConfirmDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    console.log('dialog data', this.data)
    this.dialogData = this.data;
  }

  resume(): any {
    this.dialogRef.close()
  }

  quitLearning(): any {
    this.dialogRef.close('quit')
  }

}